import { WorkflowManager } from "..";
import Handlebars from "handlebars";

/**
 * Attempts to render the template text. If the render fails for any reason, the original text will be returned.
 * @param text The template.
 * @param workflowManager The workflowManger to fetch the templating context for.
 * @returns The rendered text, or the original text if the render failed.
 */
export function renderTextTemplateForWorkflow(text: string, workflowManager: WorkflowManager): string {
    return renderTextTemplate(text, workflowManager.getTemplatingContext());
}

/**
 * Attempts to render the template text. If the render fails for any reason, the original text will be returned.
 * @param text The template.
 * @param context The rendering context.
 * @returns The rendered text, or the original text if the render failed.
 */
export function renderTextTemplate(text: string, context: any): string {
    try {
        text = Handlebars.compile(text)(context);
    } catch (e: any) {
        console.error("failed to render templated text", e);
    }
    return text;
}
